import { Client } from '../Model/Client';
import { Integrator } from '../Model/Integrator';
import { storeApi } from './storeApi';

export const clientApi = storeApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccessTokenList: builder.query<Client[], void>({
      query: () => {
        return {
          url: '/integrator/tokens',
        };
      },
      providesTags: (result) =>
        result
          ? [...result.map(({ _id }) => ({ type: 'Client', _id } as const)), { type: 'Client', id: 'LIST' }]
          : [{ type: 'Client', id: 'LIST' }],
    }),
    getIntegratorList: builder.query<Integrator[], void>({
      query: () => '/integrators',
    }),

    createAccessToken: builder.mutation<{ client_id: string; client_secret: string }, Partial<Integrator>>({
      query: ({ _id }) => ({
        url: '/integrator/token',
        method: 'POST',
        body: { integrator: _id },
      }),
      invalidatesTags: [{ type: 'Client', id: 'LIST' }],
    }),
    revokeToken: builder.mutation<void, Partial<Client>>({
      query(body) {
        return {
          url: '/integrator/token',
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [{ type: 'Client', _id }],
    }),
  }),
});

export const {
  useLazyGetAccessTokenListQuery,
  useLazyGetIntegratorListQuery,
  useCreateAccessTokenMutation,
  useRevokeTokenMutation,
} = clientApi;
